module.exports = __webpack_public_path__ + "static/15.3_romes_decline_and_legacy-94a306efff1f3b80162adb4e785a7144.pdf";